import React from 'react'
import {withAITracking} from '@microsoft/applicationinsights-react-js'
import {startAppInsight} from './util/tracking/appInsight'
import {RequestInterceptor} from './util/axiosInterceptor'
import reactPlugin from './util/tracking/reactPlugin'
import './App.scss'
import {useMatchedRoute} from './util/routing'
import {Snackbar} from './genericComponents/Snackbar'
import {initHotJar} from './util/tracking/hotjar'

startAppInsight()
const DEFAULT_PORTAL_TITLE = 'DATX '

const App: React.FC<any> = ({children}) => {

    initHotJar()
    
    const routes = useMatchedRoute()
    const pageTitle = routes?.[0]?.route.options?.pageTitle
    
    return (
        <RequestInterceptor>
            <div className="main-app-container" data-testid="main-app-container">
                <title>{DEFAULT_PORTAL_TITLE + (pageTitle ?  `- ${pageTitle}` : '')}</title>
                {children}
                <Snackbar/>
            </div>
        </RequestInterceptor>
    )
}
export default withAITracking(reactPlugin, App)
